import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import router from "./routes/index";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import "./index.css";
import "./styles/swiper.css";
import { networkUtils } from "./config/firebase";

// Initialize error tracking
const initializeErrorTracking = () => {
  // Track unhandled errors
  window.addEventListener('error', (event) => {
    console.error("Global error caught:", event.error);
    // Add any error reporting service integration here
  });

  // Track unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error("Unhandled Promise rejection:", event.reason);
    // Add any error reporting service integration here
  });

  // Track network status changes
  networkUtils.addNetworkStatusListener((isOnline) => {
    if (!isOnline) {
      console.warn('Application is offline');
    } else {
      console.log('Application is online');
    }
  });
};

// Initialize the application
const initializeApp = () => {
  try {
    // Initialize error tracking
    initializeErrorTracking();

    // Get the root element
    const rootElement = document.getElementById("root");
    if (!rootElement) {
      throw new Error("Root element not found");
    }

    // Create the root and render the app
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </React.StrictMode>
    );
  } catch (error) {
    console.error("Failed to initialize application:", error);
    // Show a user-friendly error message
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100vh;
          padding: 20px;
          text-align: center;
          font-family: system-ui, -apple-system, sans-serif;
        ">
          <h1 style="color: #dc2626; margin-bottom: 16px;">
            Application Initialization Failed
          </h1>
          <p style="color: #4b5563; margin-bottom: 24px;">
            We're sorry, but the application failed to start. Please try refreshing the page.
          </p>
          <button
            onclick="window.location.reload()"
            style="
              background-color: #2563eb;
              color: white;
              padding: 8px 16px;
              border-radius: 6px;
              border: none;
              cursor: pointer;
              font-size: 16px;
            "
          >
            Refresh Page
          </button>
        </div>
      `;
    }
  }
};

// Start the application
initializeApp();